export const fontSize10 = "6rem";
export const fontSize01 = "1.4rem";
export const fontSize02 = "1.6rem";
export const fontSize03 = "1.8rem";
export const fontSize04 = "2rem";
export const fontSize05 = "2.4rem";
export const fontSize06 = "2.8rem";
export const fontSize07 = "3.2rem";
export const fontSize08 = "4rem";
export const fontSize09 = "4.8rem";
export const fontWeightLight = 300;
export const fontWeightRegular = 400;
export const fontWeightMedium = 500;